export default __webpack_public_path__ + "static/media/icone telefone.5afb6dc5.svg";